import { TagDto } from "src/swagger/api.client.generated";

export class ScoreData {
  constructor(
    text: string,
    stars: number,
    scoreType: ScoreType,
    autoCompleteData?: string[],
    selectedTags?: TagDto[],
    tags?: TagDto[]
  ) {
    this.text = text;
    this.stars = stars;
    this.scoreType = scoreType;
    this.autoCompleteData = autoCompleteData;
    this.tags = tags;
    this.selectedTags = selectedTags;
  }

  autoCompleteData: string[] = [];
  scoreType: ScoreType;
  text: string;
  stars: number;
  tags: TagDto[] = [];
  selectedTags: TagDto[] = [];

}

export enum ScoreType {
  Halo,
  Zombie
}
